import { createAction } from "@reduxjs/toolkit";

export const setProgrammaError = createAction<string | null>(
  "programma/setError",
);
